import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Pencil, Trash2, Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";
import { api, errMsg, imgSrc } from "@/lib/api";
import { BackupButton } from "@/components/BackupButton";

export default function AdminArticles() {
  const [arts, setArts] = useState([]);
  const [del, setDel] = useState(null);
  const load = () => api.get("/articles", { params: { limit: 200 } }).then((r) => setArts(r.data));
  useEffect(() => { load(); }, []);

  const confirmDelete = async () => {
    try { await api.delete(`/articles/${del.id}`); toast.success("Berita dihapus"); load(); }
    catch (e) { toast.error(errMsg(e)); }
    setDel(null);
  };

  return (
    <div className="fade-up">
      <div className="flex items-center justify-between mb-8">
        <h1 className="font-serif text-3xl font-extrabold">Semua Berita <span className="text-slate-400 text-xl">({arts.length})</span></h1>
        <div className="flex gap-2">
        <BackupButton />
        <Button asChild data-testid="new-article-button"><Link to="/admin/berita/baru"><Plus size={16} /> Tulis Berita</Link></Button>
        </div>
      </div>
      <div className="bg-white border border-slate-200 divide-y divide-slate-100">
        {arts.length === 0 && <p className="p-8 text-slate-500">Belum ada berita.</p>}
        {arts.map((a) => (
          <div key={a.id} className="flex items-center gap-4 p-4" data-testid={`admin-article-row-${a.id}`}>
            <img src={imgSrc(a.image_url)} alt="" className="w-20 h-14 object-cover bg-slate-100 shrink-0" />
            <div className="flex-1 min-w-0">
              <Link to={`/berita/${a.slug}`} className="font-semibold text-slate-900 hover:text-[#C8102E] line-clamp-1">{a.title}</Link>
              <p className="text-xs text-slate-500 mt-1">{a.category?.name || "Tanpa kategori"} · {new Date(a.created_at).toLocaleDateString("id-ID")} · {a.views || 0} dibaca</p>
            </div>
            <Button variant="outline" size="icon" asChild data-testid={`edit-article-${a.id}`}><Link to={`/admin/berita/${a.id}/edit`}><Pencil size={15} /></Link></Button>
            <Button variant="outline" size="icon" onClick={() => setDel(a)} data-testid={`delete-article-${a.id}`}><Trash2 size={15} className="text-red-600" /></Button>
          </div>
        ))}
      </div>
      <AlertDialog open={!!del} onOpenChange={(o) => !o && setDel(null)}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Hapus berita?</AlertDialogTitle>
            <AlertDialogDescription>"{del?.title}" akan dihapus permanen.</AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel data-testid="cancel-delete-button">Batal</AlertDialogCancel>
            <AlertDialogAction onClick={confirmDelete} data-testid="confirm-delete-button" className="bg-red-600 hover:bg-red-700">Hapus</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </div>
  );
}
